import { Directive, ElementRef, Output, EventEmitter, HostListener, OnInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appClickedOutside]',
  standalone: true
})
export class ClickedOutsideDirective implements OnInit, OnDestroy {
  constructor(private ele: ElementRef) { }

  @Output() clickOutside = new EventEmitter();
  
  private clickHandler = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    
    const clickedInside = this.ele.nativeElement.contains(target);
    
    const isModalBackdrop = target.classList.contains('modal-backdrop');
    
    const isDropdownElement = target.closest('.multi-select-dropdown') || 
                             target.closest('.dropdown-content') ||
                             target.closest('.dropdown-trigger') ||
                             target.closest('.dropdown-options') ||
                             target.closest('.dropdown-search');
    
    const isCheckboxOrLabel = 
      target.tagName === 'INPUT' && target.getAttribute('type') === 'checkbox' ||
      target.tagName === 'LABEL' && target.classList.contains('app-checkbox') ||
      target.tagName === 'SPAN' && target.parentElement?.classList.contains('app-checkbox');
    
    
    if (!clickedInside && !isCheckboxOrLabel && !isModalBackdrop && !isDropdownElement) {
      // setTimeout(() => {
      // }, 0);
      this.clickOutside.emit();

    }
  };

  ngOnInit() {
    document.addEventListener('click', this.clickHandler, true);
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.clickHandler, true);
  }
}